import { render, staticRenderFns } from "./watermarkingCapacity.vue?vue&type=template&id=388e43e2&scoped=true&"
import script from "./watermarkingCapacity.vue?vue&type=script&lang=js&"
export * from "./watermarkingCapacity.vue?vue&type=script&lang=js&"
import style0 from "./watermarkingCapacity.vue?vue&type=style&index=0&id=388e43e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e43e2",
  null
  
)

export default component.exports